import logo from "../images/RT-logo-alt.png"

import '../App.css';

function Navbar() {
    return (
        <div className="navbar z-50 px-10 py-3 font-rescue bg-rescueRed lg:bg-white sticky top-0">
        <div className="navbar-start !w-full lg:!w-1/2">
          <div className="dropdown">
            <div tabIndex={0} role="button" className="btn btn-ghost lg:hidden menu-dropdown-toggle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="white">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16" />
              </svg>
            </div>
            <ul
              tabIndex={0}
              className="menu menu-sm dropdown-content bg-zinc-800 rounded-box mt-3 w-52 shadow-none ">
                <li className="menu-item"><a href="/">Home</a></li>
              <li className="menu-item"><a href="/about-us">About Us</a></li>
              <li className="menu-item"><a href="/services">Services</a></li>
              <li className="menu-item"><a href="#footer">Contact Us</a></li>
            </ul>
          </div>
          <div className="xs:hidden flex flex-row justify-center items-center">
          <a href="/"><img src={logo} width={200} className="rounded-xl ml-12 p-2 shadow-none" alt="logo"/></a>
          </div>
          
        </div>
        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal px-1">
          <li className="menu-item"><a href="/">Home</a></li>
            <li className="menu-item"><a href="/about-us">About Us</a></li>
            <li className="menu-item"><a href="/services">Services</a></li>
            <li className="menu-item"><a href="#footer">Contact Us</a></li>
          </ul>
        </div>
        <div className="navbar-end">
          <a href="/book" className="hidden md:flex btn btn-sm !text-white bg-rescueRed hover:bg-white hover:!text-rescueRed">Book Now</a>
        </div>
      </div>
    );
  }  
  export default Navbar;